import React, { FC } from 'react'
import SkeletonText from '../SkeletonText'
import './index.scss'

/** 瀑布流的skeleton */
const WaterfallSkeleton: FC = () => {
  return (
    <div className='waterfall-skeleton'>
      <div className='title'>
        <SkeletonText animated style={{ width: '10%', height: '18px' }} />
      </div>
      <div className='product-list'>
        <div className='product-item'>
          <SkeletonText animated style={{ width: '100%', height: '160px' }} />
          <SkeletonText animated style={{ width: '80%', 'marginTop': '8px' }} />
          <SkeletonText animated style={{ width: '40%', 'marginTop': '8px' }} />
          <SkeletonText animated style={{ width: '60%', 'marginTop': '8px' }} />
        </div>
        <div className='product-item'>
          <SkeletonText animated style={{ width: '100%', height: '200px' }} />
          <SkeletonText animated style={{ width: '80%', 'marginTop': '8px' }} />
          <SkeletonText animated style={{ width: '40%', 'marginTop': '8px' }} />
          <SkeletonText animated style={{ width: '60%', 'marginTop': '8px' }} />
        </div>
        <div className='product-item'>
          <SkeletonText animated style={{ width: '100%', height: '200px' }} />
          <SkeletonText animated style={{ width: '80%', 'marginTop': '8px' }} />
          <SkeletonText animated style={{ width: '40%', 'marginTop': '8px' }} />
          <SkeletonText animated style={{ width: '60%', 'marginTop': '8px' }} />
        </div>
        <div className='product-item'>
          <SkeletonText animated style={{ width: '100%', height: '220px' }} />
          <SkeletonText animated style={{ width: '80%', 'marginTop': '8px' }} />
          <SkeletonText animated style={{ width: '40%', 'marginTop': '8px' }} />
          <SkeletonText animated style={{ width: '60%', 'marginTop': '8px' }} />
        </div>
      </div>
    </div>
  )
}

export default WaterfallSkeleton
